/* Opia ozel davranislar. layout/theme.liquid <head> icinden defer ile yuklenir.
   Hicbir bolume bagli degildir. */
(function(){
  function isCart(){return document.body.className.indexOf('template-cart')>-1;}
  function isProduct(){return document.body.className.indexOf('template-product')>-1;}

  /* Turkce buyuk I tuzagi: 'İ'.toLowerCase() => 'i' + U+0307 birlesen nokta.
     Duz indexOf('isim bask') bu yuzden ESLESMEZ. NFD ile ayristirip
     birlesen isaretleri atiyoruz. */
  function sadelestir(s){
    return (s||'').normalize('NFD').replace(/[̀-ͯ]/g,'').toLowerCase().replace(/\s+/g,' ').trim();
  }

  /* Urun fiyatini sayfadaki Product JSON-LD'sinden oku (her urun sayfasinda var). */
  function urunFiyati(){
    var bloklar=document.querySelectorAll('script[type="application/ld+json"]');
    for(var i=0;i<bloklar.length;i++){
      var veri;try{veri=JSON.parse(bloklar[i].textContent);}catch(e){continue;}
      var dugumler=Array.isArray(veri)?veri:(veri['@graph']||[veri]);
      for(var j=0;j<dugumler.length;j++){
        var n=dugumler[j];
        if(n&&n['@type']==='Product'&&n.offers){
          var o=Array.isArray(n.offers)?n.offers[0]:n.offers;
          var f=parseFloat(o&&o.price);
          if(!isNaN(f))return f;
        }
      }
    }
    return null;
  }

  /* 26 Eyl 2026 - VAAT/MEKANIZMA TUTARLILIGI
     Guven seridindeki "Isim Baskisi" rozeti urun sablonundaki custom-liquid
     blogunda SABIT duruyor ve urunun kisilestirme etiketine BAKMIYOR. Isim
     girisi alani ise etikete bagli. Etiketi olmayan urunde musteri vaadi
     okuyor ama ismi girecek alani bulamiyordu.
     Kural: mekanizma yoksa o vaat gosterilmez; yerine o urun icin DOGRU olan
     baska bir guvence yazilir. Etiketten ve sablondan bagimsiz calisir
     (kadin cantalari product.kadin-cantalar.json, Fiesta ve Belle varsayilan
     sablonu kullaniyor; bu yontem ikisini de kapsar).
     Kadin canta hattinin tamami 3.400 TL ve uzeri, yani 3.000 TL ucretsiz
     kargo esigini istisnasiz geciyor -> kargo rozeti her zaman dogru.
     3.000 TL altindaki bir urun bu duruma duserse 3 yil onarim guvencesi
     yazilir; o da site genelinde dogrulanmis bir taahhut. */
  var IKON_KARGO='<path d="M3 7.5h10.5v8H3z"/><path d="M13.5 10.5h3.7l2.8 2.8v2.2h-6.5z"/><circle cx="7" cy="17.6" r="1.5"/><circle cx="16.8" cy="17.6" r="1.5"/>';
  var IKON_ONARIM='<path d="M12 3.2l6.8 2.9v4.8c0 4.3-2.9 7.7-6.8 9.6-3.9-1.9-6.8-5.3-6.8-9.6V6.1z"/><path d="M9.2 12.1l2 2 3.8-3.9"/>';

  function guvenSeridiTutarliligi(){
    if(!isProduct())return;
    if(document.querySelector('[name^="properties["]'))return;
    var items=document.querySelectorAll('.opia-trust__item');
    for(var i=0;i<items.length;i++){
      var b=items[i].querySelector('b');
      if(!b||sadelestir(b.textContent).indexOf('isim bask')<0)continue;
      var alt=items[i].querySelector('i');
      var svg=items[i].querySelector('svg');
      var fiyat=urunFiyati();
      var kargoyaUygun=(fiyat===null)||(fiyat>=3000);
      if(kargoyaUygun){
        b.textContent='Ücretsiz Kargo';
        if(alt)alt.textContent='Bu üründe kargo bizden';
        if(svg)svg.innerHTML=IKON_KARGO;
      }else{
        b.textContent='3 Yıl Onarım';
        if(alt)alt.textContent='Üretim hatasına karşı';
        if(svg)svg.innerHTML=IKON_ONARIM;
      }
    }
  }

  /* Mobilde sabit odeme cubugu: gercek buton ekranda degilken gorunur */
  function cartBar(){
    if(!isCart()||document.querySelector('.opia-cbar'))return;
    var btn=document.querySelector('.cart__submit');
    var sub=document.querySelector('.cart__footer-subtotal span:last-child');
    if(!btn||!sub)return;
    var bar=document.createElement('div');
    bar.className='opia-cbar';
    bar.innerHTML='<div class="opia-cbar__sum"><span class="opia-cbar__lbl">Alt Toplam</span><span class="opia-cbar__val"></span></div>'
      +'<button type="button" class="opia-cbar__btn">Ödemeye Git</button>';
    bar.querySelector('.opia-cbar__val').textContent=sub.textContent.trim();
    bar.querySelector('.opia-cbar__btn').addEventListener('click',function(){btn.click();});
    document.body.appendChild(bar);
    if('IntersectionObserver' in window){
      new IntersectionObserver(function(entries){
        entries.forEach(function(en){ bar.classList.toggle('is-on',!en.isIntersecting); });
      },{threshold:0}).observe(btn);
    } else { bar.classList.add('is-on'); }
    var mo=new MutationObserver(function(){
      var s=document.querySelector('.cart__footer-subtotal span:last-child');
      if(s)bar.querySelector('.opia-cbar__val').textContent=s.textContent.trim();
    });
    var fw=document.querySelector('.cart__footer-subtotal-wrapper');
    if(fw)mo.observe(fw,{childList:true,subtree:true,characterData:true});
  }

  /* NOT: Eski cartFooter() kaldirildi. Sepet sayfasinda gercek footer
     26 Eyl 2026'da layout/theme.liquid icinde geri acildi; ince yasal
     baglanti satiri artik mukerrerdi. */

  function init(){guvenSeridiTutarliligi();cartBar();}
  if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',init);}else{init();}
  window.addEventListener('load',init);
})();
